<template>
  <div
    v-if="hasRole('ui', 'UI_ALL_COMPANIES') && selectedCompany"
    class="table__alert"
  >
    {{ $t(`${namespace}.tableMessage`) }} <strong>{{ selectedCompany.name }}</strong>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'

export default {
  namespace: 'Views.UsagePoliciesPage',
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.CreditPoliciesPage'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
